export const iepSections: Record<string, string> = {
    studentNeedsSpecalFactors: 'StudentNeedsSpecalFactors',
    presentPerformance: 'PresentPerformance',
    eligibilty: 'IEP',
    measuableAnnualGoal: 'IEPMeasuableAnnualGoal',
    measuablePostSecondaryGoals: 'MeasurablePostsecondary',
    iEPReportingToParents: 'IEPReportingToParents',
    iepProgramServices: 'IEPProgramServices',
    testingAcccommodation: 'testingAcccommodation',
    behavioralInterventionServices: 'BehaviourInterventionPlan',
    participateAssessment: 'ParticipateAssessment',
    promotionCriteria: 'PromotionCriteria',
    studentsWithoutDisabilities: 'ParticipationWithoutDisability',
    transportationPlacement: 'SpecialTransportation',
    progressReport: 'ProgressReport',
    summary: 'IEPSummary',
    compensatoryServices: 'CompensatoryService',
    specificLearningJustification: 'SpecLearningJustification',
    emotionalDisabilityJustification: 'EmotionalDisability',
    educationalBenefitReviewProcess: 'EducationalBenefitReviewProcess',
    iEPCoordinatedTransitionActivities: 'IEPCoordinatedTransitionActivities',
    cbst: 'CBST',
    comparableServicePlan: 'CSP',
    meeting: 'Meeting',
    iEPIneligibility: 'IEPIneligibility',
    declassification: 'IEPDeclassification',
    sectionLevelStatus: 'IEPSectionLevelStatus',
    iEPConsent: 'IEPConsent',
    IEPPersonallyIdentifiableInformation: 'IEPPersonallyIdentifiableInformation'
}
